/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TipoPraticaIstitutoPlessoAssegnazioneCreationForm { 
    classe?: string;
    sezione?: string;
    contributo?: number;
    attivo?: boolean;
}

